import 'oskari-bundle!../../bundles/lang-overrides';
import 'oskari-bundle!oskari-frontend/bundles/framework/mapfull';
import 'oskari-loader!oskari-frontend/packages/framework/bundle/oskariui/bundle.js';
import 'oskari-loader!oskari-frontend/packages/framework/bundle/ui-components/bundle.js';
import 'oskari-loader!oskari-frontend/packages/framework/bundle/divmanazer/bundle.js';
import 'oskari-bundle!oskari-frontend/bundles/mapping/mapmodule/map2d_ol';
import 'oskari-bundle!oskari-frontend/bundles/mapping/toolbar';
import 'oskari-bundle!oskari-frontend/bundles/mapping/drawtools';
import 'oskari-bundle!../../bundles/file-layerlist';
import '../../bundles/hacks.js';
import './css/overwritten.css';
import { addAccessLogNotice } from '../../bundles/accesslog/hook.js';
Oskari.on('app.start', function () {
  addAccessLogNotice();
});